import { PlanDetail } from '@types';
import { useServiceResponse } from '../useServiceResponse';

export const usePromotionalCodeDuration = (plan?: PlanDetail): number | undefined => {
	const { retrievePromoCodeDetail } = useServiceResponse();

	const durationPromoCode = retrievePromoCodeDetail?.promoCodeDetail?.promoValue;

	// const durationPromoCode =
	// 	retrievePromoCodeDetail?.promoCodeDetail?.xinfoPromoCode
	// 		?.find((x) => x.name?.toLowerCase() === 'campaign')
	// 		?.val?.replace('M', '') || 0;

	// IF Promo code starts with CON, this discount applies only to the Total plan
	// if (
	// 	retrievePromoCodeInformation &&
	// 	retrievePromoCodeInformation.code &&
	// 	retrievePromoCodeInformation.code.indexOf('CON') >= 0 &&
	// 	plan?.name === 'Starter'
	// ) {
	// 	durationPromoCode = undefined;
	// }
	try {
		return durationPromoCode ? parseInt(durationPromoCode) : undefined;
	} catch (err) {
		return undefined;
	}
};
